module.exports = __webpack_public_path__ + "static/img/merchant_feature_3.c789063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_3.png
// module id = sjwR
// module chunks = 8